import IcInvoiceVF from './IcInvoiceVF'
export default IcInvoiceVF
